export default __webpack_public_path__ + "static/media/laptop_ko.57359f77.png";